export default __webpack_public_path__ + "static/bike-51f92cdda89afe4d11991832ad090b69.png";